export const MAX_GROUP_DESCRIPTION_LENGTH = 50;

export function validateGroupDisplayName(name?: string) {
  if (!name) return "Name can't be empty.";
  return '';
}

export function validateGroupDescription(description?: string) {
  if (!description) return 'Please enter a description.';
  if (description.length > MAX_GROUP_DESCRIPTION_LENGTH) {
    return `Description must contain fewer than ${MAX_GROUP_DESCRIPTION_LENGTH} characters.`;
  }
  return '';
}
